module.exports = __webpack_public_path__ + "img/pic7.33ffc7a7.png";